/* eslint-disable react/require-default-props */
import React, { useEffect } from 'react';
import { find } from 'lodash';
import moment from 'moment';
import PropTypes from 'prop-types';
import PopOverMenu from '../../../PopOverMenu';
import TMSEventsList from '../TMSEventsList';

import { getEventsListByEventType, EventTypes, getEventsFromIndex, isClubAdminOrOwner } from '../../../../utils/clubs';
import { EventHsTypes, EventScheduleTypes } from '../../../../utils/eventConstants';

import styles from '../../../../pages/ClubProfiles/club.scss';

const _ = { find };

const EventsTabContent = (props) => {
    const { auth,
        coreUI,
        eventsTabState,
        isAdminOrOwner,
        canRunEvents,
        isOwner,
        isPersonalClub,
        isTournamentClub,
        tmsEventsFetchState,
        clubIsFreeCollege,
        onUpgradeToCollegeClick,
        onShowAllClick,
        onCreateEventClick,
        clubDetails,
        fetchClubTMSEventsList,
        fetchClubDraftTMSEventsList,
        isClubMember,
        clubIsFreeSchool,
        onUpgradePerformanceHsClick,
    } = props;
    const { RECENT, UPCOMING, INPROGRESS } = EventScheduleTypes;
    const otherHsEventCount = clubDetails.otherHsEventCount || 0;
    const otherHsDraftEventCount = clubDetails.otherHsDraftEventCount || 0;

    const totalOtherHsEventCount = clubDetails?.tierType.isHighSchool && isClubAdminOrOwner(clubDetails) ? clubDetails.otherHsDemoEventCount || 0 : 0;
    const totalOtherDraftHsEventCount = clubDetails?.tierType.isHighSchool && isClubAdminOrOwner(clubDetails) ? clubDetails.otherHsDraftDemoEventCount || 0 : 0;
    const tmsEventCount = clubDetails.tierType.isHighSchool ? otherHsEventCount + totalOtherHsEventCount : clubDetails.tmsEventsCount;
    const draftEventCount = clubDetails.tierType.isHighSchool ? otherHsDraftEventCount + totalOtherDraftHsEventCount : clubDetails.draftEventsCount;
    const eventsFetched = clubDetails.tierType.isHighSchool ? tmsEventsFetchState.otherHsEventsFetched : tmsEventsFetchState.eventsFetched;
    const draftEventsFetched = clubDetails.tierType.isHighSchool ? tmsEventsFetchState.otherHsDraftEventsFetched : tmsEventsFetchState.draftEventsFetched;
    const currentDate = moment();

    const hsEventType = clubDetails?.tierType.isHighSchool ? EventHsTypes.OTHER : null;
    const eventListData = (eventsTabState && clubDetails)
    ? getEventsListByEventType(clubDetails, eventsTabState.eventsType, EventTypes.TMS, null, hsEventType)
    : [];

    const getEventList = () => {
        if (eventsTabState.eventsType === INPROGRESS) {
            return eventListData?.filter(event => event?.momentStartDate?.isSameOrBefore(currentDate) && event?.momentEndDate?.isAfter(currentDate));
        }
        if (eventsTabState.eventsType === UPCOMING) {
            return eventListData?.filter(event => event?.momentStartDate?.isAfter(currentDate) && event?.published);
        }
        return eventListData;
    };

        const eventList = getEventList();

    useEffect(() => {
        if (eventsTabState.eventsType === RECENT && clubDetails.tierType.isHighSchool === true) {
            const list = eventList.filter(e => e.hsEventType?.id === EventHsTypes.OTHER);
            if (list.length === 0 && otherHsEventCount !== 0) {
                fetchClubTMSEventsList(null, EventHsTypes.OTHER, 0, 5);
            }
        }
    }, [clubDetails.tierType.isHighSchool && eventsTabState.eventsType === RECENT]);

    useEffect(() => {
        if (eventsTabState.eventsType === 'draft' && clubDetails.tierType.isHighSchool === true) {
            const list = eventList.filter(e => e.hsEventType?.id === EventHsTypes.OTHER);
            if (list.length === 0 && otherHsDraftEventCount !== 0) {
                fetchClubDraftTMSEventsList(null, EventHsTypes.OTHER, 0, 5);
            }
        }
    }, [clubDetails.tierType.isHighSchool && eventsTabState.eventsType === 'draft']);

    const menuList = [
        {
            value: UPCOMING,
            label: 'Upcoming Events',
        },
        {
            value: INPROGRESS,
            label: 'In Progress Events',
        },
        {
            value: RECENT,
            label: 'Past Events',
        },
        {
            value: 'draft',
            label: 'Draft Events',
            show: isAdminOrOwner,
        },
    ];

    const selected = _.find(menuList, { value: eventsTabState.eventsType });

    return (
        <>
            <div>
                <div className={`d-inline-block ${styles.titleMargins}`}>
                    <PopOverMenu
                        anchorClass={`${styles.anchorClass}`}
                        menuItems={menuList}
                        onSelected={(option) => {
                            eventsTabState.eventsType = option.value;
                            props.updateEventsTabState(eventsTabState);
                        }}
                        alignLeft={true}
                    >
                        <h6 className={`text-uppercase mt0 mb0 pl8`}>
                            {selected ? selected.label : 'Upcoming events'} <i className={`${styles.arrow} uts uts-expand`} />
                        </h6>
                    </PopOverMenu>
                </div>
            </div>
            {eventsTabState.eventsType && (
                <>
                    <TMSEventsList
                        eventsList={getEventsFromIndex(eventList)}
                        type={eventsTabState.eventsType}
                        showAll={true}
                        auth={auth}
                        coreUI={coreUI}
                        isAdminOrOwner={isAdminOrOwner}
                        canRunEvents={canRunEvents}
                        isOwner={isOwner}
                        isPersonalClub={isPersonalClub}
                        isTournamentClub={isTournamentClub}
                        isClubMember={isClubMember}
                        tmsEventsFetchState={tmsEventsFetchState}
                        clubIsFreeCollege={clubIsFreeCollege}
                        onUpgradeToCollegeClick={onUpgradeToCollegeClick}
                        onShowAllClick={onShowAllClick}
                        onCreateEventClick={onCreateEventClick}
                        clubStatus={clubDetails.statusType}
                        clubIsFreeSchool={clubIsFreeSchool}
                        onUpgradePerformanceHsClick={onUpgradePerformanceHsClick}
                    />
                    {(eventsTabState.eventsType === RECENT || eventsTabState.eventsType === INPROGRESS) && (
                        <div className="d-flex flex-row align-items-center">
                            {!tmsEventsFetchState.loading && !tmsEventsFetchState.eventsListExhausted && (tmsEventCount > eventsFetched) && (
                                <button
                                    className="btn btn-default btn-xl mt16 mr-auto"
                                    type="button"
                                    onClick={() => {
                                        if (clubDetails.tierType.isHighSchool) {
                                            fetchClubTMSEventsList(null, EventHsTypes.OTHER);
                                        } else {
                                            fetchClubTMSEventsList();
                                        }
                                    }}
                                >
                                    Load More
                                </button>
                            )}
                        </div>
                    )}
                    {(eventsTabState.eventsType === 'draft') && (
                        <div className="d-flex flex-row align-items-center">
                            {!tmsEventsFetchState.loading && (draftEventCount > draftEventsFetched) && (
                                <button
                                    className="btn btn-default btn-xl mt16 mr-auto"
                                    type="button"
                                    onClick={() => {
                                        if (clubDetails.tierType.isHighSchool) {
                                            fetchClubDraftTMSEventsList(null, EventHsTypes.OTHER);
                                        } else {
                                            fetchClubDraftTMSEventsList();
                                        }
                                    }}
                                >
                                    Load More
                                </button>
                            )}
                        </div>
                    )}
                </>
            )}
        </>
    );
};
 EventsTabContent.propTypes = {
        auth: PropTypes.instanceOf(Object).isRequired,
        coreUI: PropTypes.instanceOf(Object).isRequired,
        eventsTabState: PropTypes.shape({
            eventsType: PropTypes.string,
        }),
        isAdminOrOwner: PropTypes.bool,
        canRunEvents: PropTypes.bool,
        isOwner: PropTypes.bool,
        isPersonalClub: PropTypes.bool,
        isTournamentClub: PropTypes.bool,
        tmsEventsFetchState: PropTypes.string,
        clubIsFreeCollege: PropTypes.bool,
        onUpgradeToCollegeClick: PropTypes.func,
        onShowAllClick: PropTypes.func,
        onCreateEventClick: PropTypes.func,
        clubDetails: PropTypes.shape({
            tierType: PropTypes.string,
        }),
        fetchClubTMSEventsList: PropTypes.func,
        fetchClubDraftTMSEventsList: PropTypes.func,
        isClubMember: PropTypes.bool,
        clubIsFreeSchool: PropTypes.bool,
        onUpgradePerformanceHsClick: PropTypes.func,
};
export default EventsTabContent;
